import * as React from "react";
import type { AutoCompleteProps } from "~/components/AutoComplete/AutoComplete";
import AutoComplete from "~/components/AutoComplete/AutoComplete";
import type { GlobalConnectedProps } from "~/components/form/VariableLookup/VariableLookup";
import { withVariableLookup } from "~/components/form/VariableLookup/VariableLookup";

const AutoCompleteWithInputRef = (props: AutoCompleteProps & GlobalConnectedProps) => <AutoComplete {...props} />;
export const VariableLookupAutoComplete = withVariableLookup()(AutoCompleteWithInputRef);
